module.exports = __webpack_public_path__ + "static/media/logo.8d515622.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.svg
// module id = 107
// module chunks = 0